import { useNavigate } from 'react-router-dom';
import { Badge, Button } from '../../../components/ui';
import { dateFilter, optionsFilter } from '../../../components/common/ListPage/listFilters';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';
import { labelOf } from '../../../utils/labels';
import { PAYMENT_MODES } from '../../../constants/payments';
import { masterLabel, masterOptions } from '../../masters/services/masterService';
import { useMasters } from '../../masters/hooks/useMasters';
import { formatDate } from '../../../utils/date';
import { money } from '../../../utils/currency';

const TABS = [
  { value: 'active', label: 'Active' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: '', label: 'All' },
];

export default function ExpenseList() {
  const navigate = useNavigate();
  useMasters();
  const add = <Button leftIcon="plus" onClick={() => navigate('/expenses/new')}>Add expense</Button>;
  return (
    <ListPage
      title="Expenses"
      path="/expenses"
      tabs={TABS}
      filters={[dateFilter(), { key: 'category', label: 'Category', icon: 'grid', options: masterOptions('expenseCategory') }, optionsFilter('paymentMode', 'Paid by', PAYMENT_MODES, 'wallet')]}
      searchPlaceholder="Number, paid to, bill no"
      actions={add}
      rowTo={(e) => `/expenses/${e._id}`}
      rowActions={(e) =>
        [
          { label: 'View', icon: 'eye', onClick: () => navigate(`/expenses/${e._id}`) },
          e.status === 'active' && { label: 'Edit', icon: 'edit', onClick: () => navigate(`/expenses/${e._id}/edit`) },
          e.serviceId && { label: 'Open job', icon: 'wrench', onClick: () => navigate(`/jobs/${e.serviceId}`) },
        ].filter(Boolean)
      }
      columns={[
        { header: 'Expense no.', sort: 'expenseNo', sortDesc: true, render: (e) => e.expenseNo, csv: (e) => e.expenseNo },
        { header: 'Date', sort: 'date', sortDesc: true, render: (e) => formatDate(e.date), csv: (e) => formatDate(e.date) },
        { header: 'Category', sort: 'category', render: (e) => <Badge tone="neutral">{masterLabel('expenseCategory', e.category)}</Badge>, csv: (e) => masterLabel('expenseCategory', e.category) },
        { header: 'Paid to', sort: 'vendorName', render: (e) => <Cell title={e.vendorName || '-'} sub={e.notes} />, csv: (e) => e.vendorName },
        { header: 'Paid by', sort: 'paymentMode', render: (e) => labelOf(PAYMENT_MODES, e.paymentMode), csv: (e) => labelOf(PAYMENT_MODES, e.paymentMode) },
        { header: 'GST', sort: 'gstAmount', sortDesc: true, align: 'right', render: (e) => (e.gstAmount ? money(e.gstAmount) : '-'), csv: (e) => (e.gstAmount ?? 0) / 100, defaultHidden: true },
        {
          header: 'Amount', sort: 'amount', sortDesc: true,
          align: 'right',
          render: (e) => <span className={e.status === 'cancelled' ? 'text-ink-400 line-through' : 'font-semibold text-navy-900'}>{money(e.amount)}</span>,
          csv: (e) => e.amount / 100,
        },
      ]}
      mobile={(e) => ({
        title: e.vendorName || masterLabel('expenseCategory', e.category),
        subtitle: [formatDate(e.date), masterLabel('expenseCategory', e.category), e.expenseNo].join(' · '),
        right: money(e.amount),
        badge: e.status === 'cancelled' ? <Badge tone="red">Cancelled</Badge> : null,
      })}
      empty={{ icon: 'moneyOut', title: 'No expenses yet', message: 'Record fuel, tools, rent and other spending. It is also recorded as money out.', action: add }}
    />
  );
}
